module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.2072b138.jpg";